import inverted from './inverted.json';
import leftBorder from './leftBorder.json';
import shadowed from './shadowed.json';
import simple from './simple.json';
import solidBorder from './solidBorder.json';

export default { simple, inverted, leftBorder, solidBorder, shadowed };
